import ButtonPrimary from 'components/ButtonPrimary'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { hasFreeTrialEndedUserSelect } from 'modules/training/modules/training-users/selectors/has-free-trial-ended/index.js'
import { getPathnameWithQueryLocationUtil } from 'modules/router/utils/get-pathname-with-query/index.js'
import { getSelectedSubscriptionPlanSelect } from 'modules/training/modules/training-premium/selectors/get-selected-subscription-plan/index.js'
import { isPremiumPlusSubscriptionUserUtil } from 'models/daos/user/utils/is-premium-plus-subscription/index.js'
import { hasPremiumPlusUserSelect } from 'modules/training/modules/training-users/selectors/has-premium-plus/index.js'
import { getPremiumPlusYearlyUrlUserSelect } from 'modules/training/modules/training-users/selectors/get-premium-plus-yearly-url/index.js'

const ANALYTIC_EVENT_LABEL = {
  TRY_PREMIUM_PLUS_FREE: 'TRY_PREMIUM_PLUS_FREE'
}

const messages = defineMessages({
  tryPremiumPlus: {
    id: 'TryPremiumPlusFreeButton.tryPremiumPlus',
    defaultMessage: 'Start Free Trial 💎'
  },
  getPremiumPlus: {
    id: 'TryPremiumPlusFreeButton.getPremiumPlus',
    defaultMessage: 'Get Premium Plus 💎'
  },
  viewPremiumPlus: {
    id: 'TryPremiumPlusFreeButton.viewPremiumPlus',
    defaultMessage: 'View Premium Plus 💎'
  }
})

export function TryPremiumPlusFreeButton (props) {
  const intl = useIntl()

  const handleClickGetPremium = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT_LABEL.TRY_PREMIUM_PLUS_FREE)
  }

  const hasFreeTrialEnded = useSelector(hasFreeTrialEndedUserSelect)
  const selectedSubscriptionPlan = useSelector(getSelectedSubscriptionPlanSelect)
  const hasPremiumPlus = useSelector(hasPremiumPlusUserSelect)
  const premiumPlusYearlyUrl = useSelector(getPremiumPlusYearlyUrlUserSelect)

  let url
  if (isPremiumPlusSubscriptionUserUtil(selectedSubscriptionPlan)) {
    url = getPathnameWithQueryLocationUtil()
  } else {
    url = `${premiumPlusYearlyUrl}&openLogin=true`
  }

  let message
  if (hasPremiumPlus) {
    message = messages.viewPremiumPlus
  } else if (hasFreeTrialEnded) {
    message = messages.getPremiumPlus
  } else {
    message = messages.tryPremiumPlus
  }

  return (
    <View {...props} ac>
      <ButtonPrimary
        onClick={handleClickGetPremium}
        url={url}
        style={{
          width: '100%',
          overflow: 'hidden'
        }}
      >
        {formatMessageIntlUtil(intl, message)}
      </ButtonPrimary>
    </View>
  )
}
